import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import { Button, Input, Row, Col, InputNumber, Drawer, Space, Divider, Table, Popconfirm, DatePicker, Tooltip } from 'antd';
import { isMobile } from 'react-device-detect';
import { _newLine, ProductReceiptExportType, customDataImageUpload, isValidDateForm, renderVatStatusTag } from '../../utils/helpers';
import BaseSelectCustom from '../../components/Elements/BaseSelect/custom';
import BaseSelect from '../../components/Elements/BaseSelect';
import { DeleteTwoTone, QuestionCircleOutlined } from '@ant-design/icons';
import NumberFormat from 'react-number-format';
import UploadImage from '../../components/UploadImage';
import ListCurrentImage from '../../components/ListCurrentImage';
import { NotificationManager } from 'react-notifications'
// actions
import { updateSpecificProductReceiptExport } from '../../redux/actions/ProductReceiptExportActions';
import { getProductWarehouseActive } from '../../redux/actions/ProductWarehouseAction';
import { getActiveProduct, getSpecificProduct } from '../../redux/actions/ProductActions';
import { getListCustomerActive } from '../../redux/actions/customerActions';
import { getBranchActive } from '../../redux/actions/BranchActions';

class ProductReceiptExportEditForm extends Component {
    constructor() {
        super();
        this.state = {
            isLoading: false,
            items: [],
            productQuery: '',
            customerQuery: '',
            currentType: '',
            images: [],
            currentImages: [],
            isResetUploadImage: true
        };
    }
    componentDidMount() {
        this.props.getProductWarehouseActive();
        this.props.getActiveProduct();
        this.props.getListCustomerActive();
        this.props.getBranchActive();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.currentItem != this.props.currentItem) {
            if (nextProps?.currentItem?.items && Array.isArray(nextProps?.currentItem?.items)) {
                this.renderNewItem(nextProps?.currentItem?.items)
                this.setState({ currentType: nextProps?.currentItem?.type })
            } else {
                this.setState({ items: [], currentType: '' })
            }
            if (nextProps?.currentItem?.images && Array.isArray(nextProps?.currentItem?.images)) {
                this.setState({ currentImages: nextProps?.currentItem?.images })
            } else {
                this.setState({ currentImages: [] })
            }
        }
    }

    renderNewItem(items = []) {
        let new_items = items.map((item, index) => {
            return {
                id: item.id,
                product_id: item.product_id,
                name: item.name,
                code: item.code,
                regular_price: item.regular_price,
                sale_price: item.sale_price,
                quantity: item.quantity,
                quantity_in_stock: item.quantity_in_stock,
                qty_vat: item.qty_vat,
                qty_no_vat: item.qty_no_vat,
                qty_vat_pending: item.qty_vat_pending,

                original_qty_vat_stock: item.original_qty_vat_stock,
                original_qty_no_vat_stock: item.original_qty_no_vat_stock,
                original_qty_vat_pending_stock: item.original_qty_vat_pending_stock,

                qty_vat_stock: item.qty_vat_stock,
                qty_no_vat_stock: item.qty_no_vat_stock,
                qty_vat_pending_stock: item.qty_vat_pending_stock,

                amount: item.sale_price * item.quantity,
                warehouse_name: item.warehouse_name,
                warehouse_id: item.warehouse_id,
                expiry_date: item.expiry_date,
                vat_status: item.vat_status,
                note: item.note,
                unit: item.unit,
                product_status_name: item.product_status_name
            }
        })
        this.setState({
            items: new_items.filter((v, i, a) => a.findIndex(v2 => (v2.id === v.id)) === i)
        });
    }


    onDelete(id) {
        let items = this.state.items.filter(item => {
            return item.id != id;
        });
        this.renderNewItem(items)
    }

    // async onChangeItem(name, value, itemId) {
    //     let items = [...this.state.items];
    //     let index = items.findIndex(item => item.id == itemId);
    //     let currentItem = items[index];
    //     if (name === 'quantity') {
    //         if (value == '' || value == null) {
    //             value = 1
    //         }
    //         const difference = value - currentItem.quantity;
    //         currentItem.quantity_in_stock -= difference;
    //     }
    //     if (name === 'sale_price') {
    //         if (value == '' || value == null) {
    //             value = 0
    //         }
    //     }
    //     currentItem[name] = value;
    //     items[index] = currentItem;
    //     this.renderNewItem(items)
    // }

    // async onChangeItem(name, value, itemId) {
    //     let items = [...this.state.items];
    //     let index = items.findIndex(item => item.id == itemId);
    //     if (index === -1) return;

    //     let currentItem = { ...items[index] };

    //     if (currentItem.quantity_in_stock_init === undefined) {
    //         currentItem.quantity_in_stock_init = currentItem.quantity_in_stock ?? 0;
    //     }

    //     if (currentItem.quantity_old === undefined) {
    //         currentItem.quantity_old = (parseInt(currentItem.qty_vat) || 0)
    //             + (parseInt(currentItem.qty_vat_pending) || 0)
    //             + (parseInt(currentItem.qty_no_vat) || 0);
    //     }

    //     const newValue = parseInt(value ?? 0) || 0;

    //     // Copy lại để tính thử giá trị mới
    //     let tempItem = { ...currentItem, [name]: newValue };

    //     const qty_vat = parseInt(tempItem.qty_vat) || 0;
    //     const qty_vat_pending = parseInt(tempItem.qty_vat_pending) || 0;
    //     const qty_no_vat = parseInt(tempItem.qty_no_vat) || 0;

    //     const new_quantity = qty_vat + qty_vat_pending + qty_no_vat;
    //     const new_quantity_in_stock = currentItem.quantity_in_stock_init - (new_quantity - currentItem.quantity_old);

    //     // Nếu vượt quá số lượng tồn kho
    //     if (currentItem.quantity_in_stock_init == 0 && new_quantity_in_stock < 0) {
    //         // Thông báo lỗi
    //         NotificationManager.error("Số lượng xuất vượt quá số lượng tồn kho hiện tại");
    //         return; // không cập nhật state
    //     }

    //     // Cập nhật lại state nếu hợp lệ
    //     currentItem[name] = newValue;
    //     currentItem.quantity = new_quantity;
    //     currentItem.quantity_old = new_quantity;
    //     currentItem.quantity_in_stock = new_quantity_in_stock;

    //     const sale_price = parseFloat(currentItem.sale_price ?? 0) || 0;
    //     currentItem.amount = sale_price * new_quantity;

    //     items[index] = currentItem;
    //     this.renderNewItem(items);
    // }
    async onChangeItem(name, value, itemId) {
        let items = [...this.state.items];
        let index = items.findIndex(item => item.id == itemId);
        if (index === -1) return;

        let currentItem = { ...items[index] };
        const newValue = parseInt(value ?? 0) || 0;

        // Khởi tạo tồn kho gốc nếu chưa có
        if (currentItem.original_qty_vat_stock === undefined) {
            currentItem.original_qty_vat_stock = currentItem.qty_vat_stock ?? 0;
            currentItem.original_qty_no_vat_stock = currentItem.qty_no_vat_stock ?? 0;
            currentItem.original_qty_vat_pending_stock = currentItem.qty_vat_pending_stock ?? 0;
        }

        // Lấy số lượng cũ của trường được chỉnh sửa
        const oldValue = parseInt(currentItem[name] ?? 0) || 0;
        const diff = newValue - oldValue;

        // Kiểm tra từng loại tồn kho tương ứng
        if (name === 'qty_vat') {
            if (diff > 0 && currentItem.qty_vat_stock < diff) {
                NotificationManager.error('Số lượng xuất có VAT vượt quá tồn kho!');
                return;
            }
            currentItem.qty_vat_stock -= diff;
        } else if (name === 'qty_no_vat') {
            if (diff > 0 && currentItem.qty_no_vat_stock < diff) {
                NotificationManager.error('Số lượng xuất chưa VAT vượt quá tồn kho!');
                return;
            }
            currentItem.qty_no_vat_stock -= diff;
        } else if (name === 'qty_vat_pending') {
            if (diff > 0 && currentItem.qty_vat_pending_stock < diff) {
                NotificationManager.error('Số lượng xuất chờ VAT vượt quá tồn kho!');
                return;
            }
            currentItem.qty_vat_pending_stock -= diff;
        }

        // Cập nhật giá trị mới
        currentItem[name] = newValue;

        // Tính lại tổng số lượng
        const qty_vat = parseInt(currentItem.qty_vat) || 0;
        const qty_no_vat = parseInt(currentItem.qty_no_vat) || 0;
        const qty_vat_pending = parseInt(currentItem.qty_vat_pending) || 0;
        const quantity = qty_vat + qty_no_vat + qty_vat_pending;

        currentItem.quantity = quantity;
        //currentItem.quantity_in_stock = currentItem.current_quantity_in_stock - quantity;
        const current_stock = parseInt(currentItem.current_quantity_in_stock ?? 0) || 0;
        //currentItem.quantity_in_stock = current_stock - quantity;

        currentItem.quantity_in_stock =
            (parseInt(currentItem.qty_vat_stock) || 0) +
            (parseInt(currentItem.qty_no_vat_stock) || 0) +
            (parseInt(currentItem.qty_vat_pending_stock) || 0);

        // Tính lại thành tiền
        const sale_price = parseFloat(currentItem.sale_price ?? 0) || 0;
        currentItem.amount = sale_price * quantity;

        items[index] = currentItem;
        this.renderNewItem(items);
    }


    onChangeProduct(id) {
        this.setState({ isloading: true })
        this.props.getSpecificProduct(id).then((item) => {
            let quantity_export = 0
            let new_items = {
                id: item.id,
                product_id: item.id,
                name: item.name,
                code: item.code,
                regular_price: item.regular_price,
                sale_price: item.sale_price,
                quantity: quantity_export,
                quantity_in_stock: item.quantity_in_stock > 0 ? item.quantity_in_stock - quantity_export : 0,
                qty_vat: 0,
                qty_no_vat: 0,
                qty_vat_pending: 0,

                original_qty_vat_stock: item.qty_vat,
                original_qty_no_vat_stock: item.qty_no_vat,
                original_qty_vat_pending_stock: item.qty_vat_pending,

                qty_vat_stock: item.qty_vat,
                qty_no_vat_stock: item.qty_no_vat,
                qty_vat_pending_stock: item.qty_vat_pending,

                amount: item.sale_price * quantity_export,
                warehouse_name: item.warehouse_name,
                warehouse_id: item.warehouse_id,
                expiry_date: item.expiry_date,
                vat_status: item.vat_status,
                note: item.note,
                unit: item.unit,
                product_status_name: item.product_status_name
            }
            this.setState({
                items: [...this.state.items, new_items].filter((v, i, a) => a.findIndex(v2 => (v2.id === v.id)) === i),
                isloading: false
            })
        })
    }

    onSearchProduct(val) {
        this.setState({ productQuery: val }, () => {
            this.props.getActiveProduct({ keyword: val });
        })
    }

    handleScroll(e) {
        this.props.getActiveProduct({ keyword: this.state.productQuery, page: this.props.pagination.currentPage + 1 }, true);
    }

    async submit(e) {
        e.preventDefault();
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                this.setState({ isLoading: true })
                try {
                    const { items, images, currentImages } = this.state;
                    values.images = customDataImageUpload(images, currentImages);
                    values.export_date = values.export_date ? values.export_date.format("YYYY-MM-DD") : null;
                    values.items = items;
                    var total_amount = 0;
                    items.forEach(item => {
                        total_amount += item.amount;
                    });
                    values.total_amount = total_amount;
                    //console.log('values: ', values)
                    if (this.props.currentItem) {
                        this.props.updateSpecificProductReceiptExport(this.props.currentItem.id, values).then(res => {
                            this.props.reloadData();
                            this.onClose();
                        }).catch(err => {
                            this.setState({ isLoading: false });
                        })
                    }
                } catch (error) {
                    this.setState({ isLoading: false });
                }
            }
        });
    }

    onClose() {
        this.props.getActiveProduct();
        this.props.onCancel();
        this.props.form.resetFields();
        this.setState({
            isLoading: false,
            items: [],
            images: [],
            isResetUploadImage: true
        })
    }

    onSearchCustomer(val) {
        this.setState({ customerQuery: val }, () => {
            this.props.getListCustomerActive({ keyword: val });
        })
    }

    handleScrollCustomer(e) {
        this.props.getListCustomerActive({ keyword: this.state.customerQuery, page: this.props.pagination_active.currentPage + 1 });
    }

    onChangeType(value) {
        this.setState({ currentType: value })
    }

    onChangeImage = (data) => {
        this.setState({
            isResetUploadImage: false,
            images: data
        });
        NotificationManager.success("Image complete.");
    }

    getImages(data) {
        this.setState({ currentImages: data })
    }

    render() {
        var { isLoading, items, currentType, isResetUploadImage, currentImages } = this.state;
        var { visible, currentItem,
            branchActiveList,
            product_warehouse_active_list,
            product_list,
            customerActiveList
        } = this.props;
        const { getFieldDecorator } = this.props.form;
        //console.log("items: ", items)
        var columns = [
            {
                title: "STT",
                dataIndex: "stt",
                width: "40px",
                align: 'center',
                render: (text, record, index) => index + 1
            },
            {
                title: "Tên sản phẩm",
                dataIndex: "name",
                //width: "180px",
                render: (text, record) => {
                    return (<>{text}</>)
                }
            },
            {
                title: "Kho",
                dataIndex: "warehouse_name",
                width: "120px"
            },

            // {
            //     title: "SL chờ VAT",
            //     dataIndex: "qty_vat_pending",
            //     width: "100px",
            //     render: (text, record) => {
            //         return (
            //             <>
            //                 <InputNumber
            //                     formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
            //                     value={text}
            //                     name="qty_vat_pending"
            //                     min={0}
            //                     className='w-100 fix-height-input'
            //                     onChange={(value) => this.onChangeItem('qty_vat_pending', value, record.id)}
            //                 />
            //             </>
            //         )
            //     }
            // },
            // {
            //     title: "SL có VAT",
            //     dataIndex: "qty_vat",
            //     width: "100px",
            //     render: (text, record) => {
            //         return (
            //             <>
            //                 <InputNumber
            //                     formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
            //                     value={text}
            //                     name="qty_vat"
            //                     min={0}
            //                     className='w-100 fix-height-input'
            //                     onChange={(value) => this.onChangeItem('qty_vat', value, record.id)}
            //                 />
            //             </>
            //         )
            //     }
            // },

            // {
            //     title: "SL chưa VAT",
            //     dataIndex: "qty_no_vat",
            //     width: "100px",
            //     render: (text, record) => {
            //         return (
            //             <>
            //                 <InputNumber
            //                     formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
            //                     value={text}
            //                     name="qty_no_vat"
            //                     min={0}
            //                     className='w-100 fix-height-input'
            //                     onChange={(value) => this.onChangeItem('qty_no_vat', value, record.id)}
            //                 />
            //             </>
            //         )
            //     }
            // },
            // {
            //     title: 'SL xuất tổng',
            //     dataIndex: "quantity",
            //     width: "100px",
            //     render: (text, record) => {
            //         return (
            //             <>
            //                 <InputNumber
            //                     formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
            //                     value={text}
            //                     name="quantity"
            //                     disabled
            //                     max={record.quantity_in_stock + text}
            //                     min={1}
            //                     className='w-100 fix-height-input'
            //                     //onChange={(value) => this.onChangeItem('quantity', value, record.id)}
            //                     onChange={(value) => {
            //                         // Kiểm tra giá trị và thay thế nếu cần thiết
            //                         const validValue = value == null || value <= 0 ? 1 : value;
            //                         this.onChangeItem('quantity', validValue, record.id);
            //                     }}
            //                 />
            //             </>
            //         )
            //     }
            // },
            // {
            //     title: 'SL tồn',
            //     dataIndex: "quantity_in_stock",
            //     width: "100px",
            //     render: (text, record) => {
            //         return (
            //             <>
            //                 {record.quantity_in_stock}
            //             </>
            //         )
            //     }
            // },
            {
                title: (
                    <>
                        SL chờ VAT{' '}
                        <Tooltip title="Số lượng sản phẩm đang chờ xuất hóa đơn VAT. Hiển thị theo cấu trúc: Số lượng xuất / Tồn kho hiện tại">
                            <QuestionCircleOutlined style={{ color: '#1890ff', cursor: 'pointer' }} />
                        </Tooltip>
                    </>
                ),
                dataIndex: "qty_vat_pending",
                width: "120px",
                render: (text, record) => {
                    return (
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <InputNumber
                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                value={text}
                                name="qty_vat_pending"
                                min={0}
                                className='fix-height-input'
                                style={{ width: '70%' }}
                                onChange={(value) => this.onChangeItem('qty_vat_pending', value, record.id)}
                            />
                            <div style={{ color: "#999", marginLeft: 2 }}>
                                / {record.qty_vat_pending_stock || 0}
                            </div>
                        </div>
                    );
                }
            },
            {
                title: (
                    <>
                        SL có VAT{' '}
                        <Tooltip title="Số lượng sản phẩm đã xuất có hóa đơn VAT. Hiển thị theo cấu trúc: Số lượng xuất / Tồn kho hiện tại">
                            <QuestionCircleOutlined style={{ color: '#1890ff', cursor: 'pointer' }} />
                        </Tooltip>
                    </>
                ),
                dataIndex: "qty_vat",
                width: "110px",
                render: (text, record) => {
                    return (
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <InputNumber
                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                value={text}
                                name="qty_vat"
                                min={0}
                                className='fix-height-input'
                                style={{ width: '70%' }}
                                onChange={(value) => this.onChangeItem('qty_vat', value, record.id)}
                            />
                            <div style={{ color: "#999", marginLeft: 2 }}>
                                / {record.qty_vat_stock || 0}
                            </div>
                        </div>
                    );
                }
            },
            {
                title: (
                    <>
                        SL chưa VAT{' '}
                        <Tooltip title="Số lượng sản phẩm đã xuất chưa có hóa đơn VAT. Hiển thị theo cấu trúc: Số lượng xuất / Tồn kho hiện tại">
                            <QuestionCircleOutlined style={{ color: '#1890ff', cursor: 'pointer' }} />
                        </Tooltip>
                    </>
                ),
                dataIndex: "qty_no_vat",
                width: "120px",
                render: (text, record) => {
                    return (
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <InputNumber
                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                value={text}
                                name="qty_no_vat"
                                min={0}
                                className='fix-height-input'
                                style={{ width: '70%' }}
                                onChange={(value) => this.onChangeItem('qty_no_vat', value, record.id)}
                            />
                            <div style={{ color: "#999", marginLeft: 2 }}>
                                / {record.qty_no_vat_stock || 0}
                            </div>
                        </div>
                    );
                }
            },
            {
                title: (
                    <>
                        SL xuất tổng{' '}
                        <Tooltip title="Tổng số lượng sản phẩm sẽ xuất trong phiếu này">
                            <QuestionCircleOutlined style={{ color: '#1890ff', cursor: 'pointer' }} />
                        </Tooltip>
                    </>
                ),
                dataIndex: "quantity",
                width: "120px",
                render: (text, record) => {
                    return (
                        <>
                            <InputNumber
                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                value={text}
                                name="quantity"
                                disabled
                                max={record.current_quantity_in_stock}
                                min={1}
                                className='w-100 fix-height-input'
                                //onChange={(value) => this.onChangeItem('quantity', value, record.id)}
                                onChange={(value) => {
                                    // Kiểm tra giá trị và thay thế nếu cần thiết
                                    const validValue = value == null || value <= 0 ? 1 : value;
                                    this.onChangeItem('quantity', validValue, record.id);
                                }}
                            />
                        </>
                    )
                }
            },
            {
                title: (
                    <>
                        SL tồn{' '}
                        <Tooltip title="Tổng tồn kho hiện tại của sản phẩm (cộng cả VAT, chưa VAT và chờ VAT)">
                            <QuestionCircleOutlined style={{ color: '#1890ff', cursor: 'pointer' }} />
                        </Tooltip>
                    </>
                ),
                dataIndex: "quantity_in_stock",
                width: "100px",
                render: (text, record) => {
                    return (
                        <>
                            {record.quantity_in_stock}
                        </>
                    )
                }
            },
            {
                title: "Giá bán",
                dataIndex: "sale_price",
                width: "100px",
                render: (text, record) => {
                    return (
                        <InputNumber
                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            value={text}
                            name="sale_price"
                            step={1000}
                            min={0}
                            className='w-100 fix-height-input'
                            onChange={(value) => this.onChangeItem('sale_price', value, record.id)}
                        />
                    )
                }
            },
            {
                title: "Thành tiền",
                dataIndex: "amount",
                width: "100px",
                render: (text, record) => {
                    return (
                        <NumberFormat value={text} displayType={'text'} suffix="đ" thousandSeparator={true} />
                    )
                }
            },
            {
                title: "Đơn vị tính",
                dataIndex: "unit",
                width: "100px"
            },
            {
                title: "Hạn sử dụng",
                dataIndex: "expiry_date",
                width: "120px"
            },
            // {
            //     title: "Trạng thái VAT",
            //     dataIndex: "vat_status",
            //     width: "120px",
            //     render: (text, record) => {
            //         return (<>{renderVatStatusTag(text)}</>)
            //     }
            // },
            {
                title: "#",
                align: "center",
                width: '30px',
                render: (text, record) => {
                    return (
                        <Popconfirm
                            title="Xóa sản phẩm này?"
                            onConfirm={() => this.onDelete(record.id)}
                        >
                            <DeleteTwoTone twoToneColor="#fe0000" />
                        </Popconfirm>
                    )
                }
            }
        ];

        var total_amount = 0;
        items.forEach(item => {
            total_amount += item.amount;
        });

        return (
            <Drawer
                visible={visible}
                title={`Sửa phiếu: ${currentItem?.name + " - " + currentItem?.code}`}
                onOk={(e) => this.submit(e)}
                onClose={() => this.onClose()}
                maskClosable={false}
                width={isMobile ? '100%' : '90%'}
                footer={
                    <Row justify="end">
                        <Space>
                            <Button key="back" onClick={() => this.onClose()}>
                                Huỷ
                            </Button>
                            <Button loading={isLoading} key="submit" type="primary" onClick={(e) => this.submit(e)}>
                                Cập nhật
                            </Button>
                        </Space>
                    </Row>
                }
            >
                {visible ?
                    <Form layout='vertical'>
                        <Row gutter={16}>
                            <Col xs={24} md={24}>
                                <Divider orientation="left" orientationMargin="0">
                                    Thông tin sản phẩm
                                </Divider>
                                <Row gutter={16}>
                                    <Col xs={24} md={24}>
                                        <BaseSelectCustom
                                            options={product_list}
                                            optionValue="id"
                                            optionLabel="name"
                                            additionalLabel1="quantity"
                                            additionalLabel2="expiry_date_format"
                                            additionalLabel3="warehouse_name"
                                            showSearch
                                            allowClear={false}
                                            defaultValue="Chọn sản phẩm có sẵn trong kho"
                                            placeholder="Chọn sản phẩm có sẵn trong kho"
                                            onSearch={(val) => this.onSearchProduct(val)}
                                            onScrollEnd={(e) => this.handleScroll(e)}
                                            onChange={(id) => this.onChangeProduct(id)}
                                            className="w-100 mb-2"
                                        />
                                    </Col>
                                    <Col xs={24} md={24}>
                                        <Table
                                            className='mt-2'
                                            size='small'
                                            rowKey='key'
                                            tableLayout="auto"
                                            columns={columns}
                                            dataSource={items || []}
                                            pagination={false}
                                            loading={isLoading}
                                            locale={{ emptyText: "Chưa có dữ liệu" }}
                                            scroll={{
                                                x: 'max-content'
                                            }}
                                        />
                                    </Col>
                                </Row>
                                <Row justify="end" gutter={16} className='mt-4'>
                                    <Col xs={24} md={24} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                        <h5>Tổng tiền: <NumberFormat value={total_amount} displayType={'text'} suffix="đ" thousandSeparator={true} /></h5>
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs={24} md={24}>
                                <Divider orientation="left" orientationMargin="0">
                                    Thông tin phiếu
                                </Divider>
                                <div className='box-info'>
                                    <Row gutter={16}>
                                        <Col xs={24} md={6}>
                                            <Form.Item label="Tên phiếu">
                                                {getFieldDecorator('name', {
                                                    rules: [
                                                        {
                                                            required: true,
                                                            message: 'Vui lòng điền!',
                                                        },
                                                    ],
                                                    initialValue: currentItem ? currentItem.name : ""
                                                })(<Input />)}
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} md={6}>
                                            <Form.Item label="Loại phiếu">
                                                {getFieldDecorator('type', {
                                                    rules: [
                                                        {
                                                            required: true,
                                                            message: 'Vui lòng điền!',
                                                        },
                                                    ],
                                                    initialValue: currentItem ? currentItem.type : null
                                                })(
                                                    <BaseSelect
                                                        options={ProductReceiptExportType}
                                                        placeholder="Loại phiếu"
                                                        style={{ width: '100%' }}
                                                        onChange={(value) => this.onChangeType(value)}
                                                    />
                                                )}
                                            </Form.Item>
                                        </Col>
                                        {
                                            currentType == 'ban' || currentType == 'xuatchokhach' ? (
                                                <Col xs={24} md={6}>
                                                    <Form.Item label={<>Khách hàng: </>}>
                                                        {getFieldDecorator("customer_id", {
                                                            rules: [
                                                                {
                                                                    required: true,
                                                                    message: "Vui lòng chọn!",
                                                                },
                                                            ],
                                                            initialValue: currentItem ? currentItem?.customer_id : null
                                                        })(
                                                            <BaseSelect
                                                                options={customerActiveList || []}
                                                                optionValue="id"
                                                                optionLabel="full_name"
                                                                additionalLabel="code"
                                                                allowClear
                                                                showSearch
                                                                placeholder="Mã, tên khách hàng"
                                                                onSearch={(val) => this.onSearchCustomer(val)}
                                                                onScrollEnd={(e) => this.handleScrollCustomer(e)}
                                                                style={{ width: '100%' }}
                                                            />
                                                        )}
                                                    </Form.Item>
                                                </Col>
                                            ) : null
                                        }
                                        {
                                            currentType == 'chuyenkho' ? (
                                                <Col xs={24} md={6}>
                                                    <Form.Item label="Chuyển đến kho">
                                                        {getFieldDecorator('warehouse_to_id', {
                                                            rules: [
                                                                {
                                                                    required: true,
                                                                    message: 'Vui lòng điền!',
                                                                },
                                                            ],
                                                            initialValue: currentItem ? currentItem.warehouse_to_id : null
                                                        })(<BaseSelect
                                                            options={product_warehouse_active_list || []}
                                                            optionValue="id"
                                                            optionLabel="name"
                                                            showSearch
                                                            placeholder="Chọn kho sản phẩm"
                                                            style={{ width: '100%' }}
                                                        />)}
                                                    </Form.Item>
                                                </Col>
                                            ) : null
                                        }
                                        {
                                            currentType == 'cososudung' ? (
                                                <Col xs={24} md={6}>
                                                    <Form.Item label="Cơ sở">
                                                        {getFieldDecorator('branch_id', {
                                                            rules: [
                                                                {
                                                                    required: true,
                                                                    message: 'Vui lòng điền',
                                                                },
                                                            ],
                                                            initialValue: currentItem ? currentItem.branch_id : null
                                                        })(
                                                            <BaseSelect
                                                                options={branchActiveList || []}
                                                                optionValue="id"
                                                                optionLabel="name"
                                                                placeholder="Chọn cơ sở"
                                                                className="w-100"
                                                            />
                                                        )}
                                                    </Form.Item>
                                                </Col>
                                            ) : null
                                        }
                                        <Col xs={24} md={6}>
                                            <Form.Item label="Ngày xuất kho">
                                                {getFieldDecorator('export_date', {
                                                    rules: [
                                                        {
                                                            required: true,
                                                            message: 'Vui lòng điền!',
                                                        },
                                                    ],
                                                    initialValue: currentItem ? isValidDateForm(currentItem.export_date, true) : null
                                                })(
                                                    <DatePicker
                                                        format="DD/MM/YYYY"
                                                        placeholder="Chọn ngày"
                                                        className='w-100'
                                                    />
                                                )}
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} md={24}>
                                            <Form.Item label="Ảnh phiếu" className='flex-upload'>
                                                <ListCurrentImage currentImages={currentImages} getData={(data) => this.getImages(data)} />
                                                {getFieldDecorator('images', {
                                                    rules: [
                                                        {
                                                            required: false,
                                                            message: 'Vui lòng điền!',
                                                        },
                                                    ],
                                                    initialValue: null
                                                })(
                                                    <UploadImage
                                                        multiple={true}
                                                        maxCount={30}
                                                        onChangeData={this.onChangeImage}
                                                        isResetUpload={isResetUploadImage}
                                                    />
                                                )}
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <Form.Item label="Ghi chú">
                                        {getFieldDecorator('note', {
                                            rules: [
                                                {
                                                    required: false,
                                                    message: "Vui lòng điền!",
                                                },
                                            ],
                                            initialValue: currentItem ? _newLine(currentItem.note) : ""
                                        })(
                                            <Input.TextArea />
                                        )}
                                    </Form.Item>
                                </div>
                            </Col>
                        </Row>
                    </Form>
                    : null}
            </Drawer>
        )
    }
}

function mapStateToProps(state) {
    return {
        product_supplier_active_list: state.ProductSupplierReducer.product_supplier_active_list,
        product_warehouse_active_list: state.ProductWarehouseReducer.product_warehouse_active_list,
        product_list: state.ProductReducer.product_list,
        pagination: state.ProductReducer.pagination,
        customerActiveList: state.customerReducer.activeList.items,
        pagination_active: state.customerReducer.activeList.pagination,
        branchActiveList: state.BranchReducer.branchActiveList,
        config: state.config
    }
}

function mapDispatchToProps(dispatch) {
    return {
        updateSpecificProductReceiptExport: (id, data) => dispatch(updateSpecificProductReceiptExport(id, data)),
        getProductWarehouseActive: () => dispatch(getProductWarehouseActive()),
        getActiveProduct: (filter, concatenate) => dispatch(getActiveProduct(filter, concatenate)),
        getSpecificProduct: (id) => dispatch(getSpecificProduct(id)),
        getBranchActive: () => dispatch(getBranchActive()),
        getListCustomerActive: (filter) => dispatch(getListCustomerActive(filter))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Form.create({ name: 'ProductReceiptExportEditForm' })(ProductReceiptExportEditForm));
